import { render, staticRenderFns } from "./appendix-liquid.vue?vue&type=template&id=f0e21f32&scoped=true"
import script from "./appendix-liquid.vue?vue&type=script&lang=js"
export * from "./appendix-liquid.vue?vue&type=script&lang=js"
import style0 from "./appendix-liquid.vue?vue&type=style&index=0&id=f0e21f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e21f32",
  null
  
)

export default component.exports